// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */
import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import {extractCaller} from "../QueryPage";
import type {GenericModalDispatchProps, GenericModalStateProps} from "../../components/GenericModal";
import GenericModal from "../../components/GenericModal";
import type {Caller} from "../../components/QueryPage";
import EBadge from "../../model/ebadge/EBadge";
import {closeEBadgeButtonModalAction, eBadgeButtonAction} from "../../actions/ebadge/creators/eBadgeButtonActionCreator";
import {changeEBadgeVerificationStatus} from "../../dao/eBadgeDao";

function getIsLoadingStatus(state, registrationCode) {
    let status = state.eBadgeAction['invalidate'] && state.eBadgeAction['invalidate'][registrationCode];
    if (status) {
        return status.isLoading;
    } else {
        return false;
    }
}

type Args = {
    registrationCode: string,
    caller: Caller
}

const mapStateToProps = (state: StoreState): GenericModalStateProps => {

    const registrationCode = state.modal['invalidate'] && state.modal['invalidate'].identifier;
    const isLoading = registrationCode ? getIsLoadingStatus(state, registrationCode)
        : false;

    const args: Args = {
        registrationCode: registrationCode || '',
        caller: extractCaller(state)
    };
    return {
        open: state.modal['invalidate'] && state.modal['invalidate'].open,
        promptMsg: `Are you sure to invalidate ${registrationCode || 'EBadge'}? `,
        loadingMsg: `OK. We are invalidating ${registrationCode || 'EBadge'}`,
        isLoading,
        error: state.eBadgeAction['invalidate'] && state.eBadgeAction['invalidate'].error,
        primaryActionText: 'Invalidate',
        primaryActionColor: "danger",
        primaryActionClassName: "light-red",
        args: args
    }
};

const mapDispatchToProps = (dispatch): GenericModalDispatchProps => {
    return {
        primaryAction: (args: Args) => {
            dispatch(eBadgeButtonAction(args.registrationCode, args.caller, "invalidate",
                async (registrationCode, caller, authToken) => {
                    return await changeEBadgeVerificationStatus(registrationCode, caller, authToken, "N")
                }));
        },
        closeModal: () => {
            dispatch(closeEBadgeButtonModalAction("invalidate"));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(GenericModal);



// WEBPACK FOOTER //
// ./src/containers/ebadge/InvalidateEBadgeModal.js